import { render, staticRenderFns } from "./grid-drag-element.vue?vue&type=template&id=1bc1baaa&scoped=true&"
import script from "./grid-drag-element.vue?vue&type=script&lang=js&"
export * from "./grid-drag-element.vue?vue&type=script&lang=js&"
import style0 from "./grid-drag-element.vue?vue&type=style&index=0&id=1bc1baaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1baaa",
  null
  
)

export default component.exports